import { render } from "./FilterBadge.vue?vue&type=template&id=7e8c201e&scoped=true"
import script from "./FilterBadge.vue?vue&type=script&lang=js"
export * from "./FilterBadge.vue?vue&type=script&lang=js"

import "./FilterBadge.vue?vue&type=style&index=0&id=7e8c201e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8c201e"]])

export default __exports__